<button type="button" (click)="open()" class="btn btn-outline-primary w-100"><i
        class="fas fa-magnifying-glass me-1"></i> Consultar factura</button>
<nz-drawer [nzClosable]="false" [nzVisible]="visible" [nzPlacement]="isMobile ? 'bottom' : 'left'"
    nzTitle="Consulta factura" nzSize="large" [nzWidth]="600" [nzFooter]="footerConsulta">
    <ng-container *nzDrawerContent>
        <div class="row">
            <div class="col-12">
                <p class="mb-2">
                    Para tu comodidad también puedes descargar
                    la factura en diversos formatos, haciendo click
                    en los botones de la sección lateral.
                </p>
                <p class="mb-0">
                    Es posible que al comenzar la descarga, tu navegador
                    solicite un permiso para completar la acción.
                </p>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <table class="table table-sm d-none d-md-table">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th>N° de Ticket</th>
                            <th>RFC Receptor</th>
                            <th>Total</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="facturaConsultada">
                            <td class="text-center">{{ facturaConsultada.numeroOrden }}</td>
                            <td class="text-center">{{ facturaConsultada.rfcReceptor }}</td>
                            <td class="text-end">{{ facturaConsultada.total | currency }}</td>
                            <td class="text-end">
                                <a (click)="downloadPDF(facturaConsultada.pdf ,facturaConsultada.nombrePdf)" class="text-danger" nz-tooltip
                                    nzTooltipTitle="Descargar PDF" nzTooltipPlacement="top">
                                    <i class="fas fa-file-arrow-down"></i>
                                </a>
                                <a (click)="downloadXML(facturaConsultada.xml, facturaConsultada.nombreXml)" class="text-success mx-3"
                                    nz-tooltip nzTooltipTitle="Descargar XML" nzTooltipPlacement="top">
                                    <i class="fas fa-file-arrow-down"></i>
                                </a>
                                <a class="text-warning" (click)="isCollapsed = !isCollapsed" nz-tooltip
                                    nzTooltipTitle="Enviar por email" nzTooltipPlacement="top">
                                    <i class="fas fa-envelope"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-sm d-md-none">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th [colSpan]="4">Datos factura</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="facturaConsultada">
                            <td class="text-center">
                                <p class="mb-2 d-flex justify-content-between">
                                    <span style="font-size: 13px;" class="text-secondary">{{
                                        facturaConsultada.numeroOrden }} | {{ facturaConsultada.rfcReceptor
                                        }}</span>
                                    <span>{{ facturaConsultada.total | currency }}</span>
                                </p>
                                <p class="mb-0 d-flex justify-content-end">
                                    <a (click)="downloadPDF(facturaConsultada.pdf ,facturaConsultada.nombrePdf)" class="text-danger" nz-tooltip
                                        nzTooltipTitle="Descargar PDF" nzTooltipPlacement="top">
                                        <i class="fas fa-file-arrow-down"></i>
                                    </a>
                                    <a (click)="downloadXML(facturaConsultada.xml, facturaConsultada.nombreXml)" class="text-success mx-3"
                                        nz-tooltip nzTooltipTitle="Descargar XML" nzTooltipPlacement="top">
                                        <i class="fas fa-file-arrow-down"></i>
                                    </a>
                                    <a class="text-warning" (click)="isCollapsed = !isCollapsed" nz-tooltip
                                        nzTooltipTitle="Enviar por email" nzTooltipPlacement="top">
                                        <i class="fas fa-envelope"></i>
                                    </a>
                                </p>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
            <form (ngSubmit)="sendEmail()" [formGroup]="formEmail" class="row">
                <div class="col-12">
                    <h6>Enviar mi factura por email</h6>
                </div>
                <div class="col-md-12 mt-1">
                    <nz-select nzMode="tags" (keydown.enter)="addEmail()" nzPlaceHolder="Ingresa los emails..."
                        style="width: 100%;" formControlName="email"></nz-select>
                </div>
                <div class="col-md-12 mt-2 text-end">
                    <button type="submit" [disabled]="formEmail.invalid || isLoading"
                        class="btn btn-primary basic-label"><i *ngIf="!isLoading" class="fas fa-paper-plane me-2"></i>
                        <div *ngIf="isLoading" class="spinner-border spinner-border-sm text-light me-2" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Enviar
                    </button>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #footerConsulta>
        <div class="row">
            <div class="col-12 text-end">
                <button class="btn btn-primary btn-sm basic-paragraph" (click)="close()"><i
                        class="fas fa-times me-1"></i>Cerrar</button>
            </div>
        </div>
    </ng-template>
</nz-drawer>

@if (searchingTicket) {
<app-loader-full [configInitial]="configInitial"></app-loader-full>
}